import { Typography } from '@mui/material';
import Modal from 'components/Modal';
import Cookie from 'assets/images/graphic-cookie-consent.svg';
import TertiaryButton from 'components/TertiaryButton';
import { Content, StyledButton, Image, StyledTypography } from './CookieConsent.styles';

interface CookieConsentProps {
  isOpen: boolean;
  onClose: () => void;
}

function CookieConsent({ isOpen, onClose }: CookieConsentProps) {
  const disableOnClose = () => null;

  return (
    <Modal
      open={isOpen}
      closeType="none"
      onClose={disableOnClose}
      aria-label="Cookie Consent Modal"
    >
      <Content>
        <Typography variant="h2" gutterBottom>
          Hello
        </Typography>
        <Image src={Cookie} />
        <StyledTypography variant="body1" gutterBottom>
          We use cookies to provide you with a better service. By continuing to use this site, you
          are agreeing to the use of cookies
        </StyledTypography>
        <TertiaryButton href="https://www.zizzi.co.uk/cookie-policy" target="_blank">
          Cookie policy
        </TertiaryButton>
        <TertiaryButton href="https://www.zizzi.co.uk/privacy-policy" target="_blank">
          Privacy policy
        </TertiaryButton>
        <StyledButton fullWidth variant="contained" color="primary" onClick={onClose}>
          Okay
        </StyledButton>
      </Content>
    </Modal>
  );
}

export default CookieConsent;
